import { Image as ImageIcon, ArrowUpRight, Sparkles } from "lucide-react";

export const PortfolioCard = ({ project }) => {
  const isPlaceholder = !project.name;

  return (
    <div className="glass-card overflow-hidden flex flex-col h-full" data-testid="portfolio-card">
      <div className="relative aspect-video flex items-center justify-center">
        {project.image ? (
          <div className="w-full h-full bg-white flex items-center justify-center p-6">
            <img src={project.image} alt={project.name} className="max-h-full max-w-full object-contain" />
          </div>
        ) : (
          <div className={`w-full h-full bg-gradient-to-br ${project.accent} flex items-center justify-center`}>
            <div className="absolute inset-0 bg-[#020B1D]/55" />
            <div className="relative z-10 flex flex-col items-center text-center">
              <ImageIcon size={30} className="text-[#F7FAFF]/80" />
              <span className="mt-2 text-xs font-semibold text-[#F7FAFF]/80 tracking-wide">Preview coming soon</span>
            </div>
          </div>
        )}
        {project.featured && (
          <span className="absolute top-3 left-3 z-10 inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wide px-3 py-1.5 rounded-full bg-gradient-to-r from-[#087CFF] to-[#00A8FF] text-white shadow-[0_0_16px_rgba(0,168,255,0.4)]">
            <Sparkles size={12} /> Featured
          </span>
        )}
      </div>

      <div className="p-5 flex flex-col flex-1">
        {isPlaceholder ? (
          <div className="flex-1 flex items-center">
            <p className="text-sm text-[#7F92AE]">New project coming soon.</p>
          </div>
        ) : (
          <>
            <h3 className="text-lg font-bold text-[#F7FAFF]">{project.name}</h3>
            <p className="mt-2 text-sm text-[#AEBFD8] leading-relaxed flex-1">{project.desc}</p>
            <a href={project.url} target="_blank" rel="noopener noreferrer" data-testid={`view-project-${project.slug}`}
              className="btn-secondary mt-5 inline-flex items-center justify-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold min-h-[44px]">
              View Project <ArrowUpRight size={16} />
            </a>
          </>
        )}
      </div>
    </div>
  );
};
